module.exports = __webpack_public_path__ + "img/wallet.d2075d8c.png";